import * as Sentry from "@sentry/react";

const server = process.env.REACT_APP_SERVER_ENV;
const environment = process.env.NODE_ENV || "development";
const isProd = environment === "production";
const isLocal = server === "LOCAL";

if (!isLocal) {
    Sentry.init({
        dsn: process.env.REACT_APP_SENTRY_DSN,
        environment: environment,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                networkDetailAllowUrls: [
                    "localhost",
                    /^https:\/\/([a-zA-Z0-9-]+\.)+(joinee\.io|volee\.io|volee\.co|joinee\.co|devlabsco\.com)(?:\/api.*)?/,
                ],
                networkRequestHeaders: ["Community", "Public-ip"],
            }),
            Sentry.feedbackIntegration({
                colorScheme: "system",
                isEmailRequired: true,
            }),
        ],
        // Tracing
        // Capture 100% of the transactions
        tracesSampleRate: 1.0,
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
            "localhost",
            /^https:\/\/([a-zA-Z0-9-]+\.)+(joinee\.io|volee\.io|volee\.co|joinee\.co|devlabsco\.com)(?:\/api.*)?/,
        ],

        // Session Replay
        // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysSessionSampleRate: isProd ? 0.2 : 1.0,
        // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        replaysOnErrorSampleRate: 1.0,

        beforeSend(event) {
            // filter out Google Analytics requests
            if (event.breadcrumbs) {
                event.breadcrumbs = event.breadcrumbs.filter(breadcrumb =>
                    !(breadcrumb?.data?.url?.includes('google-analytics'))
                );
            }
            return event;
        },
    });
    Sentry.setTag("server", server);
}

const LazySentry = () => {
    return <></>
}

export default LazySentry;